import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  BrainCircuit,
  Smartphone,
  MonitorSmartphone,
  BadgeCheck,
  Code2,
  Braces,
  Database,
  Server,
  ShieldPlus,
  ChevronDown,
  X,
  Menu,
} from "lucide-react";
import "./MainNavbar.css";

const Menus = [
  { name: "Home", to: "/" },
  {
    name: "About",
    subMenu: [
      { name: "About us", icon: BadgeCheck, to: "/about/aboutus" },
      { name: "Our Vision", icon: BadgeCheck, to: "/about/vision" },
      { name: "Mission", icon: ShieldPlus, to: "/about/mission" },
    ],
    gridCols: 2,
  },
  {
    name: "Software courses",
    subMenu: [
      { name: "Python", icon: Database, to: "/software/python" },
      {
        name: "Full Stack",
        icon: Code2,
        subMenu: [
          {
            name: "Java Full Stack",
            icon: Code2,
            to: "/software/fullstack/java",
          },
          {
            name: "Python Full Stack",
            icon: Code2,
            to: "/software/fullstack/python",
          },
          {
            name: "PHP Full Stack",
            icon: MonitorSmartphone,
            to: "/software/fullstack/php",
          },
          {
            name: "DotNet Full Stack",
            icon: MonitorSmartphone,
            to: "/software/fullstack/dotnet",
          },
        ],
      },
      { name: "C,C++ Programming", icon: Code2, to: "/software/ccpp" },
      {
        name: "Others",
        icon: Code2,
        subMenu: [
          { name: "Tally", icon: Smartphone, to: "/software/others/tally" },
          { name: "CAD", icon: Smartphone, to: "/software/others/cad" },
          {
            name: "Accounting",
            icon: Smartphone,
            to: "/software/others/accounting",
          },
          {
            name: "Advanced Excel",
            icon: Smartphone,
            to: "/software/others/advanced-excel",
          },
          { name: "MS Excel", icon: Code2, to: "/software/others/excel" },
        ],
        gridCols: 1,
      },

      { name: "Java", icon: MonitorSmartphone, to: "/software/java" },
      {
        name: "Mobile App Development",
        icon: Code2,
        subMenu: [
          {
            name: "Flutter Development",
            icon: Smartphone,
            to: "/software/mobile/flutter",
          },
          {
            name: "React Native",
            icon: Smartphone,
            to: "/software/mobile/reactnative",
          },
        ],
        gridCols: 1,
      },
      { name: "PHP", icon: MonitorSmartphone, to: "/software/php" },
      { name: "HTML", icon: MonitorSmartphone, to: "/software/Html" },
      { name: ".NET", icon: Database, to: "/software/dotnet" },
      { name: "Basic Computer", icon: Server, to: "/software/basiccom" },
      { name: "Foxpro Programming", icon: Code2, to: "/software/foxpro" },
      // { name: "Linux", icon: Code2, to: "/software/linux" },
      { name: "SQL", icon: Code2, to: "/software/sql" },
      { name: "Node js", icon: Code2, to: "/software/node" },
      { name: "Angular", icon: Code2, to: "/software/angular" },
      { name: "React js", icon: Code2, to: "/software/react" },
      { name: "VB Script", icon: Code2, to: "/software/vbscript" },
    ],
    gridCols: 2,
  },
  {
    name: "Hardware Courses",
    subMenu: [
      { name: "A+N+", icon: Code2, to: "/hardware/a+n+" },
      { name: "CCNA", icon: Braces, to: "/hardware/ccna" },
      { name: "CCNP", icon: MonitorSmartphone, to: "/hardware/ccnp" },
      { name: "redhat linux", icon: Server, to: "/hardware/redhat" },
      { name: "Microsoft Server", icon: Server, to: "/hardware/microsoft" },
    ],
    gridCols: 1,
  },
  {
    name: "Multimedia courses",
    subMenu: [
      { name: "2D video editing", icon: BrainCircuit, to: "/multimedia/twoD" },
      {
        name: "3D video editing",
        icon: BrainCircuit,
        to: "/multimedia/threeD",
      },
      { name: "Audio editing", icon: BrainCircuit, to: "/multimedia/audio" },
      { name: "Visual Effects", icon: BrainCircuit, to: "/multimedia/VFX" },
      {
        name: "3D Animation",
        icon: BrainCircuit,
        to: "/multimedia/3d-animation",
      },
      { name: "Adobe", icon: BrainCircuit, to: "/multimedia/adobep" },

      {
        name: "Graphic Design",
        icon: Server,
        to: "/multimedia/graphic-design",
      },
      { name: "Multimedia", icon: Server, to: "/multimedia/multimedia" },
      { name: "CorelDraw", icon: Server, to: "/multimedia/corel-draw" },
      { name: "Flash", icon: BrainCircuit, to: "/multimedia/flash" },
      { name: "DTP", icon: Braces, to: "/multimedia/dtp" },
    ],
    gridCols: 2,
  },
  {
    name: "Ai course",
    icon: Code2,
    subMenu: [
      {
        name: "Data science",
        icon: Smartphone,
        to: "/software/aicourses/datascience",
      },
      {
        name: "Data Analytics",
        icon: Smartphone,
        to: "/software/aicourses/dataanalytics",
      },
      {
        name: "Machine Learning",
        icon: Smartphone,
        to: "/software/aicourses/machinelearning",
      },
      { name: "AI ML", icon: Smartphone, to: "/software/aicourses/aiml" },
    ],
    gridCols: 1,
  },
  { name: "Contact", to: "/contact" },
];

export default function MainNavbar() {
  const [isHover, setIsHover] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [clicked, setClicked] = useState(null);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
    setClicked(null);
  };

  const subMenuAnimate = {
    enter: {
      opacity: 1,
      rotateX: 0,
      transition: { duration: 0.5 },
      display: "block",
    },
    exit: {
      opacity: 0,
      rotateX: -15,
      transition: { duration: 0.5 },
      transitionEnd: { display: "none" },
    },
  };

  const subMenuDrawer = {
    enter: {
      height: "auto",
      opacity: 1,
      transition: { duration: 0.3, ease: "easeInOut" },
    },
    exit: {
      height: 0,
      opacity: 0,
      transition: { duration: 0.3, ease: "easeInOut" },
    },
  };

  const renderSubMenu = (submenus) => {
    return submenus.map((submenu, i) => {
      const hasNested = submenu.subMenu?.length;

      return (
        <div
          key={i}
          className="relative"
          onMouseEnter={(e) => {
            const menu = e.currentTarget.querySelector(".nested-submenu");
            if (menu) menu.style.display = "block";
          }}
          onMouseLeave={(e) => {
            const menu = e.currentTarget.querySelector(".nested-submenu");
            if (menu) menu.style.display = "none";
          }}
        >
          {submenu.to ? (
            // <Link
            //   to={submenu.to}
            //   className="flex items-center gap-x-4 cursor-pointer px-2 py-2 rounded-md duration-300 hover:bg-white hover:text-gray-900"
            // >
            //   <submenu.icon className="shrink-0" />
            //   <span className="font-semibold">{submenu.name}</span>
            // </Link>
            <Link
              to={submenu.to}
              onClick={() => setIsHover(null)} // ✅ closes dropdown after click
              className="flex items-center gap-x-4 cursor-pointer px-2 py-2 rounded-md duration-300 hover:bg-white hover:text-gray-900"
            >
              <submenu.icon className="shrink-0" />
              <span className="font-semibold">{submenu.name}</span>
            </Link>
          ) : (
            <span className="flex items-center gap-x-4 cursor-pointer px-2 py-2 rounded-md duration-300 hover:bg-white hover:text-gray-900">
              <submenu.icon className="shrink-0" />
              <span className="font-semibold">{submenu.name}</span>
            </span>
          )}

          {hasNested && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.25 }}
              className="nested-submenu absolute top-0 left-full ml-2 p-4 rounded-lg bg-[#0A1D3A] shadow-lg hidden"
              style={{ zIndex: 9999 }}
            >
              <div className="grid gap-4 grid-cols-1">
                {renderSubMenu(submenu.subMenu)}
              </div>
            </motion.div>
          )}
        </div>
      );
    });
  };

  return (
    <>
      <header className="h-16 text-[15px] fixed inset-0 flex-center bg-[#0A1D3A] z-50">
        <nav className="px-3.5 flex-center-between w-full max-w-7xl mx-auto">
          <div className="flex-center gap-x-3 z-[999] relative">
            <Link
              to="/"
              style={{ animation: "zoomInOut 2.5s ease-in-out infinite" }}
              className="text-3xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105"
            >
              CSG
            </Link>
          </div>

          {/* Desktop */}
          <ul
            className="gap-x-1 lg:flex-center hidden"
            style={{ color: "white" }}
          >
            {Menus.map((menu, index) => {
              const hasSubMenu = menu?.subMenu?.length;
              return (
                <motion.li
                  key={menu.name}
                  className="group/link desktop"
                  onHoverStart={() => setIsHover(index)}
                  onHoverEnd={() => setIsHover(null)}
                >
                  {hasSubMenu ? (
                    <span className="flex-center gap-1 hover:bg-white/5 cursor-pointer px-3 py-1 rounded-xl">
                      {menu.name}
                      <ChevronDown className="mt-[0.6px] group-hover/link:rotate-180 duration-200" />
                    </span>
                  ) : (
                    <Link
                      to={menu.to}
                      className="flex-center gap-1 hover:bg-white/5 px-3 py-1 rounded-xl"
                    >
                      {menu.name}
                    </Link>
                  )}

                  {hasSubMenu && (
                    <motion.div
                      className="sub-menu absolute mt-2 p-4 rounded-lg bg-[#0A1D3A] text-white shadow-lg"
                      initial="exit"
                      animate={isHover === index ? "enter" : "exit"}
                      variants={subMenuAnimate}
                    >
                      <div
                        className={`grid gap-7 ${
                          menu.gridCols === 2 ? "grid-cols-2" : "grid-cols-1"
                        }`}
                      >
                        {renderSubMenu(menu.subMenu)}
                      </div>
                    </motion.div>
                  )}
                </motion.li>
              );
            })}
          </ul>

          {/* Mobile */}
          <div className="flex-center gap-x-5">
            <div className="lg:hidden z-[999]">
              <button onClick={toggleDrawer}>
                {isOpen ? <X /> : <Menu />}
              </button>
            </div>
          </div>
        </nav>

        {/* Mobile Sidebar */}
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: isOpen ? 0 : "100%" }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="fixed top-0 right-0 w-full h-screen bg-[#0A1D3A] text-white shadow-lg mt-2 p-6 overflow-y-auto lg:hidden z-[998]"
        >
          <ul className="flex flex-col gap-4 mt-10">
            {Menus.map((menu, index) => {
              const hasSubMenu = menu?.subMenu?.length;
              return (
                <li key={menu.name} className="w-full">
                  {hasSubMenu ? (
                    <MobileMenuItem
                      menu={menu}
                      index={index}
                      clicked={clicked}
                      setClicked={setClicked}
                      toggleDrawer={toggleDrawer}
                    />
                  ) : (
                    <Link
                      to={menu.to}
                      onClick={toggleDrawer}
                      className="block px-2 py-2 rounded-lg hover:bg-white/10"
                    >
                      {menu.name}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </motion.div>
      </header>
    </>
  );
}

// Mobile Menu Item Component (nested scrollable)
function MobileMenuItem({ menu, index, clicked, setClicked, toggleDrawer }) {
  const [nestedOpen, setNestedOpen] = useState({});

  const toggleNested = (i) => {
    setNestedOpen({ ...nestedOpen, [i]: !nestedOpen[i] });
  };

  return (
    <>
      <button
        className="flex justify-between items-center w-full px-2 py-2 rounded-lg hover:bg-white/10"
        onClick={() => setClicked(clicked === index ? null : index)}
      >
        <span>{menu.name}</span>
        <ChevronDown
          className={`transform transition-transform ${
            clicked === index ? "rotate-180" : ""
          }`}
        />
      </button>

      <motion.div
        initial="exit"
        animate={clicked === index ? "enter" : "exit"}
        variants={{
          enter: { height: "auto", opacity: 1 },
          exit: { height: 0, opacity: 0 },
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="pl-4 flex flex-col gap-2 overflow-y-auto max-h-[60vh]"
      >
        {menu.subMenu.map((submenu, i) => {
          const hasNested = submenu.subMenu?.length;
          return (
            <div key={i} className="w-full">
              {hasNested ? (
                <>
                  <button
                    className="flex justify-between items-center w-full px-2 py-2 rounded-md hover:bg-white/10"
                    onClick={() => toggleNested(i)}
                  >
                    <span>{submenu.name}</span>
                    <ChevronDown
                      className={`transform transition-transform ${
                        nestedOpen[i] ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={
                      nestedOpen[i]
                        ? { height: "auto", opacity: 1 }
                        : { height: 0, opacity: 0 }
                    }
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="pl-4 flex flex-col gap-2 overflow-y-auto max-h-[50vh]"
                  >
                    {submenu.subMenu.map((nested, j) => (
                      <Link
                        to={nested.to}
                        key={j}
                        onClick={toggleDrawer}
                        className="flex items-center gap-2 px-2 py-2 rounded-md hover:bg-white/10"
                      >
                        <nested.icon size={18} />
                        {nested.name}
                      </Link>
                    ))}
                  </motion.div>
                </>
              ) : (
                <Link
                  to={submenu.to}
                  onClick={toggleDrawer}
                  className="flex items-center gap-2 px-2 py-2 rounded-md hover:bg-white/10"
                >
                  <submenu.icon size={18} />
                  {submenu.name}
                </Link>
              )}
            </div>
          );
        })}
      </motion.div>
    </>
  );
}
